import { simpleSet } from '@r/reducers/utils';

const setCalculationModePullsValue = simpleSet as
  redux.reducers.calculationMode.settings.materials.pulls.value;

export const value = setCalculationModePullsValue(
  'SET_CALCULATION_MODE_PULLS_VALUE',
  { value: '', label: '' }
);
